import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';

import Stamp from 'components/inbox/Stamp';

class InboxListItem extends Component {
    // Route props
    static propTypes = {
        location: PropTypes.object.isRequired
    };

    render = () => {

        const { state } = this.props;

        return (
            <li className={this.getClass()} key={this.props.key}>
                <Link to={'/' + this.props.view + '/' + this.props.id}>
                    <div className="mail-border" />
                    <Stamp version="horisontal" stampId={this.props.stamp} info={this.props.supportInfo} />
                    <div className="info">
                        <div className="time-stamp">
                            {!state.read && <span className="read-marker">&nbsp;</span>}
                            <img src="assets/images/inbox/ico_time.svg" alt="" />
                            <span className="date">
                                <Moment format="YYYY-MM-DD">{this.props.timestamp}</Moment>
                            </span>
                        </div>
                        <h3>{this.props.sender.name}</h3>
                        <h4>{this.props.title}</h4>
                    </div>
                </Link>
            </li>
        );
    };

    getClass() {
        const { hide } = this.props;

        var classNames = 'mail';
        if (this.isActive()) {
            classNames += ' selected';
        }
        if (hide) {
            classNames += ' animation-remove';
        }
        return classNames;
    }

    // Check if menu item is active depending on present route
    isActive() {
        const { location, view } = this.props;

        return location.pathname === '/' + view + '/' + this.props.id ? true : false;
    }
}

export default withRouter(connect()(InboxListItem));



// WEBPACK FOOTER //
// ./src/components/inbox/InboxListItem.js